import { z } from 'zod';
import { uuidSchema } from './common.js';
// -------------------------------------------------------------- shipments
/**
 * What is actually being shipped, in the units a scale and a tape measure
 * give — total ounces (not lb+oz split; the admin form combines them) and
 * inches. Nothing in the catalog carries a product weight yet (t0800), so
 * this is entered by staff at rate-quote time rather than computed.
 */
export const parcelInputSchema = z.object({
    weightOz: z.number().positive().max(2400), // 150 lb — comfortably past anything sold here
    lengthIn: z.number().positive().max(120),
    widthIn: z.number().positive().max(120),
    heightIn: z.number().positive().max(120),
});
/** A reasonable starting point for the admin rate-quote form — always shown
 *  and always editable before a rate is fetched, never bought unedited. */
export const DEFAULT_PARCEL = { weightOz: 16, lengthIn: 8, widthIn: 6, heightIn: 4 };
export const shippingRateSchema = z.object({
    /** EasyPost's shipment id — its rates only resolve within the shipment
     *  they were quoted on, so this travels with every rate and is required to
     *  buy one. */
    shipmentId: z.string(),
    rateId: z.string(),
    carrier: z.string(),
    serviceName: z.string(),
    amountCents: z.number().int().nonnegative(),
    currency: z.string(),
    deliveryDays: z.number().int().nonnegative().nullable(),
});
export const getRatesRequestSchema = z.object({ parcel: parcelInputSchema });
export const getRatesResponseSchema = z.object({ rates: z.array(shippingRateSchema) });
export const purchaseLabelSchema = z.object({
    shipmentId: z.string().min(1),
    rateId: z.string().min(1),
    /** Echoed back rather than re-read from the rate quote, so the row records
     *  exactly what staff saw and bought against — not a value the client
     *  could have gone stale on between quoting and buying. */
    parcel: parcelInputSchema,
});
export const shipmentStatusSchema = z.enum(['purchased', 'refund_pending', 'refunded', 'error']);
export const shipmentViewSchema = z.object({
    id: uuidSchema,
    orderId: uuidSchema,
    status: shipmentStatusSchema,
    carrier: z.string(),
    serviceName: z.string(),
    rateAmountCents: z.number().int(),
    rateCurrency: z.string(),
    labelUrl: z.string().nullable(),
    trackingNumber: z.string().nullable(),
    trackingUrl: z.string().nullable(),
    trackingStatus: z.string().nullable(),
    trackingUpdatedAt: z.iso.datetime().nullable(),
    parcel: parcelInputSchema,
    createdAt: z.iso.datetime(),
});
//# sourceMappingURL=shipping.js.map